/**
 * 相机：把世界坐标映射到屏幕，支持跟随、边界限制、平滑与震屏。
 */
export class Camera {
  constructor(viewW = 960, viewH = 600) {
    this.x = 0;
    this.y = 0;          // 相机左上角对应的世界坐标
    this.viewW = viewW;
    this.viewH = viewH;
    this.target = null;  // 跟随实体（需含 transform 组件）
    this.bounds = null;  // {w, h} 世界尺寸
    this.smooth = 6;     // 越大跟得越紧
    this.zoom = 1;
    this.shake = 0;
    this._sx = 0;
    this._sy = 0;
  }

  setViewport(w, h) { this.viewW = w; this.viewH = h; }
  setBounds(w, h) { this.bounds = { w, h }; }
  follow(entity) { this.target = entity; }

  /** 让相机立即贴到目标中心 */
  snapTo(x, y) {
    this.x = x - this.viewW / (2 * this.zoom);
    this.y = y - this.viewH / (2 * this.zoom);
    this._clamp();
  }

  update(dt) {
    if (this.target) {
      const t = this.target.transform;
      const tx = t.x + (t.w || 0) / 2 - this.viewW / (2 * this.zoom);
      const ty = t.y + (t.h || 0) / 2 - this.viewH / (2 * this.zoom);
      const k = 1 - Math.exp(-this.smooth * dt);
      this.x += (tx - this.x) * k;
      this.y += (ty - this.y) * k;
    }
    if (this.shake > 0) {
      this.shake = Math.max(0, this.shake - dt * 3);
      const amp = this.shake * 6;
      this._sx = (Math.random() - 0.5) * amp;
      this._sy = (Math.random() - 0.5) * amp;
    } else {
      this._sx = this._sy = 0;
    }
    this._clamp();
  }

  _clamp() {
    if (!this.bounds) return;
    const vw = this.viewW / this.zoom;
    const vh = this.viewH / this.zoom;
    this.x = this.bounds.w <= vw ? (this.bounds.w - vw) / 2 : Math.max(0, Math.min(this.bounds.w - vw, this.x));
    this.y = this.bounds.h <= vh ? (this.bounds.h - vh) / 2 : Math.max(0, Math.min(this.bounds.h - vh, this.y));
  }

  addShake(v = 1) { this.shake = Math.min(1.5, this.shake + v); }

  /** 在 ctx 上应用相机变换 */
  apply(ctx) {
    ctx.save();
    ctx.scale(this.zoom, this.zoom);
    ctx.translate(-this.x + this._sx, -this.y + this._sy);
  }

  restore(ctx) { ctx.restore(); }

  screenToWorld(sx, sy) {
    return { x: sx / this.zoom + this.x, y: sy / this.zoom + this.y };
  }

  worldToScreen(wx, wy) {
    return { x: (wx - this.x) * this.zoom, y: (wy - this.y) * this.zoom };
  }
}
